import { render, staticRenderFns } from "./DropdownContent.vue?vue&type=template&id=6a644e67&"
import script from "./DropdownContent.vue?vue&type=script&lang=ts&"
export * from "./DropdownContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports